import { CommunityLink } from '@lumapps/communities/components/CommunityLink';
import { CommunityLinkRef } from '@lumapps/communities/types';
import type { Instance } from '@lumapps/instance/types';
import { Route, Link as RouterLink } from '@lumapps/router';
import { CommunityInfo } from '@lumapps/widget-base/types';

import { eventView } from '../routes';

type EventLinkOutput =
    | {
          type: 'community-link-ref';
          linkAs: typeof CommunityLink;
          to: CommunityLinkRef;
      }
    | {
          type: 'route';
          linkAs: typeof RouterLink;
          to: Route;
      };

/** Get link component & props to link to the event view page */
export const getEventLink = (
    eventId: string,
    communityInfo?: CommunityInfo,
    anchor?: string,
    instance?: Partial<Pick<Instance, 'id' | 'slug'>>,
): EventLinkOutput => {
    if (communityInfo) {
        const to: CommunityLinkRef = {
            id: communityInfo.communityId,
            slug: communityInfo.slug,
            renderingType: communityInfo.renderingType,
            view: 'event',
            identifier: eventId,
            anchor,
            instance,
        };
        return { type: 'community-link-ref', linkAs: CommunityLink, to };
    }
    return { type: 'route', linkAs: RouterLink, to: eventView(eventId, anchor, instance?.slug) };
};
